import Box from '@material-ui/core/Box'
import Collapse from '@material-ui/core/Collapse'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Paper from '@material-ui/core/Paper'
import { createMuiTheme, lighten, makeStyles, ThemeProvider } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import shareNeeds from '../../assets/images/shareNeeds.svg'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { Button, Modal } from 'react-bootstrap'
import './MyNeeds.css'
import axios from 'axios'
import CommonLoader from '../CommonLoader'
import ApiService from '../../utils/apiservice'
import MessageCard from './MessageCard'

function createData(no, date_of_service, provider, charged, paid, status) {
  return { no, date_of_service, provider, charged, paid, status }
}

const theme = createMuiTheme({
  MuiTableCell: {
    paddingLeft: '30px'
  }
})

const rows = [
  createData('600016', '2020-04-20', 'VITALCARE FP LLC', 670, 43, 'FINAL'),
  createData('600017', '2020-05-20', 'VITALCARE FP LLC', 500, 100, 'IN REVIEW'),
  createData('600016', '2020-04-20', 'VITALCARE FP LLC', 670, 43, 'FINAL'),
  createData('600017', '2020-05-20', 'VITALCARE FP LLC', 500, 100, 'IN REVIEW'),
  createData('600016', '2020-04-20', 'VITALCARE FP LLC', 670, 43, 'FINAL'),
  createData('600017', '2020-05-20', 'VITALCARE FP LLC', 500, 100, 'IN REVIEW'),
  createData('600016', '2020-04-20', 'VITALCARE FP LLC', 670, 43, 'FINAL'),
  createData('600017', '2020-05-20', 'VITALCARE FP LLC', 500, 100, 'IN REVIEW'),
  createData('600016', '2020-04-20', 'VITALCARE FP LLC', 670, 43, 'FINAL'),
  createData('600017', '2020-05-20', 'VITALCARE FP LLC', 500, 100, 'IN REVIEW')
]

function descendingComparator(a, b, orderBy) {
  if (orderBy == 'contribution_amount') {
    if (parseFloat(b[orderBy].replace('$', '')) < parseFloat(a[orderBy].replace('$', ''))) {
      return -1
    }
    if (parseFloat(b[orderBy].replace('$', '')) > parseFloat(a[orderBy].replace('$', ''))) {
      return 1
    }
    return 0
  } else if (orderBy == 'service_date') {
    if (moment(b[orderBy]).isBefore(a[orderBy])) {
      return -1
    }
    if (moment(b[orderBy]).isAfter(a[orderBy])) {
      return 1
    }
    return 0
  } else {
    if (b[orderBy] < a[orderBy]) {
      return -1
    }
    if (b[orderBy] > a[orderBy]) {
      return 1
    }
    return 0
  }
}

function getComparator(order, orderBy) {
  return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

const headCells = [
  { key: 'reference_id', id: 'reference_id', numeric: false, disablePadding: false, label: 'Reference #' },
  { key: 'service_date', id: 'service_date', numeric: false, disablePadding: false, label: 'Date Of Service' },
  { key: 'name_initials', id: 'first_name', numeric: false, disablePadding: false, label: 'Member' },
  // { key: 'provider_name', id: 'provider_name', numeric: false, disablePadding: false, label: 'Provider' },
  // { key: 'charged_amount', id: 'charged_amount', numeric: true, disablePadding: false, label: 'Charged Amount' },
  // { key: 'paid_amount', id: 'paid_amount', numeric: true, disablePadding: false, label: 'Paid Amount' },
  { key: 'submitted_date', id: 'submitted_date', numeric: false, disablePadding: false, label: 'Submitted /Last Edit Date' },
  { key: 'status', id: 'status', numeric: false, disablePadding: false, label: 'Status' },
  { key: 'action', id: 'action', numeric: false, disablePadding: false, label: 'Action' }
]

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow className="tableHeadRow">
        {headCells.map(headCell => (
          <>
            {headCell.key == 'service_date' ? (
              <TableCell
                key={headCell.key}
                padding={headCell.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === headCell.key ? order : false}
                align={headCell.key === 'action' ? 'right' : 'left'}
                className="sortheadercellColor tableHeader myTableHead"
                style={{ borderBottom: '2px solid #2e3192' }}
              >
                <TableSortLabel
                  active={orderBy === headCell.key}
                  direction={orderBy === headCell.key ? order : 'asc'}
                  onClick={createSortHandler(headCell.key)}
                  className="headercellColor tableHeader"
                  style={{ textDecoration: 'none' }}
                >
                  {headCell.label}
                  {orderBy === headCell.key ? (
                    <span className={classes.visuallyHidden}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</span>
                  ) : null}
                </TableSortLabel>
              </TableCell>
            ) : (
              <TableCell
                key={headCell.key}
                padding={headCell.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === headCell.key ? order : false}
                align={headCell.key === 'action' ? 'right' : 'left'}
                className="headercellColor tableHeader myTableHead"
                style={{ borderBottom: '2px solid #2e3192' }}
              >
                <TableSortLabel
                  active={orderBy === headCell.key}
                  direction={orderBy === headCell.key ? order : 'asc'}
                  onClick={createSortHandler(headCell.key)}
                  className="headercellColor tableHeader"
                  style={{ textDecoration: 'none' }}
                >
                  {headCell.label}
                  {orderBy === headCell.key ? (
                    <span className={classes.visuallyHidden}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</span>
                  ) : null}
                </TableSortLabel>
              </TableCell>
            )}
          </>
        ))}
      </TableRow>
    </TableHead>
  )
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
}

const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1)
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85)
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark
        },
  title: {
    flex: '1 1 100%'
  }
}))

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  table: {
    minWidth: 750
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  },
  /* Mobile responsive styles */
  mobileContainer: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      overflow: 'auto'
    }
  },
  mobilePaper: {
    [theme.breakpoints.down('sm')]: {
      boxShadow: '0 1px 2px rgba(0,0,0,0.1) !important'
    }
  }
}))

export default function ReimbursementDataTable(props) {
  const classes = useStyles()
  const [order, setOrder] = React.useState('desc')
  const [orderBy, setOrderBy] = React.useState('createdDate')
  const [selected, setSelected] = React.useState([])
  const [page, setPage] = React.useState(0)
  const [dense, setDense] = React.useState(false)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const { tableData } = props
  const [reimbursementData, setReimbursementData] = React.useState([])
  const isIframeReimbursementFlow =
    window.location.search.includes('SC=true') &&
    window.location.search.includes('reimbursement=true')

  const [loader, setLoader] = React.useState(!isIframeReimbursementFlow)

  const normalizeReimbursementData = data => {
    if (!Array.isArray(data)) {
      return []
    }

    return data.map(item => ({
      ...item,
      reference_id: item?.reference_id || item?.referenceId || item?.claimId || item?.need_id || 'NA',
      service_date: item?.service_date || item?.serviceDate || item?.uploadedDate || item?.createdDate || '',
      name_initials: item?.name_initials || item?.memberName || item?.memberId || localStorage.getItem('Member_EMPID') || 'NA',
      provider_name: item?.provider_name || item?.providerName || item?.provider || 'NA',
      charged_amount: item?.charged_amount || item?.chargedAmount || item?.contribution_amount || item?.amount || 'NA',
      paid_amount: item?.paid_amount || item?.paidAmount || item?.amount || 'NA',
      submitted_date: item?.updatedDate || item?.createdDate || '',
      status: item?.status || 'PENDING'
    }))
  }

  useEffect(() => {
    const isIframeReimbursementFlow =
      window.location.search.includes('SC=true') &&
      window.location.search.includes('reimbursement=true')

    if (!isIframeReimbursementFlow) {
      getReimbursementData()
    }
  }, [props.tableData, window.location.hash])

  const getReimbursementData = async () => {
    setLoader(true)
    try {
      // FIX: If data parameters are sent by MyNeeds, prioritize them over cached API endpoints
      if (props.tableData && props.tableData.length > 0) {
        const normalizedData = normalizeReimbursementData(props.tableData)
        setReimbursementData(normalizedData)
        return
      }

      // Fallback API download if running inside standard layout mode
      const response = await ApiService.getReimbursementByMember()
      const normalizedData = normalizeReimbursementData(response)
      setReimbursementData(normalizedData)
    } catch (error) {
      console.error('Error fetching reimbursement data:', error)
      setReimbursementData([])
    } finally {
      setLoader(false)
    }
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n.name)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1))
    }

    setSelected(newSelected)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleChangeDense = event => {
    setDense(event.target.checked)
  }

  const isSelected = name => selected.indexOf(name) !== -1

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage)
  const isReimbursementOnly = props.forceReimbursementOnly || false;
  return (
    <div className={classes.root}>
      {loader ? <CommonLoader /> : null}
      {reimbursementData[0] ?
        <Paper className={'tableContainer ' + classes.paper + ' ' + classes.mobilePaper} style={{ marginBottom:0 }}>
        <TableContainer style={isReimbursementOnly ? {maxHeight: 'calc(78vh - 100px)'}:{ height: 'auto', maxHeight: 'calc(78vh - 300px)', overflowX: 'auto' }} className={classes.mobileContainer}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="medium"
            aria-label="enhanced table"
            stickyHeader
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />

            <TableBody>
              {
                reimbursementData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((tableData, index) => {
                  const isItemSelected = isSelected(tableData.name)
                  const labelId = `enhanced-table-checkbox-${index}`

                  return <Row open={props.open} key={tableData.name} row={tableData} onUpdateClick={props.onUpdateClick} />
                })}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          style={{ position: 'relative', fontSize: '12px', overflowX: 'auto' }}
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={reimbursementData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      :
      <div className="data_not_found">
        {!loader &&
          <MessageCard 
            type="info" 
            message="You haven't submitted any reimbursement requests yet. Click the button below to submit one."
          />
        }
      </div>
      }
    </div>
  )
}

function Row(props) {
  const { row } = props
  const [open, setOpen] = React.useState(props.open)
  const classes = useRowStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [modalShow, setModalShow] = React.useState(false)

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleUpdate = () => {
    handleMenuClose()
    if (props.onUpdateClick) {
      props.onUpdateClick(row)
    }
  }

  const getDate = date => {
    const isDateValid = moment(date)['_isValid']
    if (isDateValid) {
      return moment(date).format('MMMM D, YYYY')
    }
    return date
  }

  const getStatusBadge = status => {
    const statusStr = String(status || '').toUpperCase().trim()
    const isSubmitted = statusStr === 'SUBMITTED' || statusStr === 'FINAL' || statusStr === 'APPROVED'
    const badgeStyle = {
      padding: '4px 12px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: 'bold',
      backgroundColor: isSubmitted ? '#4CAF50' : '#F44336',
      color: 'white',
      display: 'inline-block',
      whiteSpace : 'nowrap'
    }
    const displayStatus = isSubmitted ? 'SUBMITTED' : 'NOT YET SUBMITTED'
    return <span style={badgeStyle}>{displayStatus}</span>
  }

  const numberWithCommas = x => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  const floatconversion = x => {
    return x.toFixed(2)
  }

  const combineDate = (x, y) => {
    if (x == y) {
      return x
    }

    const z = x + '-' + y
    return z
  }

  const convertToString = x => {
    console.log('Type Of X')
    console.log(x)
  }

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <TableRow className={'rowTable ' + classes.root}>
          <TableCell component="th" scope="row" align="left" className="rowcellcolor rowTableCell myTableRow">
            {row.id ? row.id : 'NA'}
          </TableCell>
          <TableCell component="th" scope="row" align="left" className="rowcellcolor rowTableCell myTableRow">
            {row.service_date ? getDate(row.service_date) : 'NA'}
          </TableCell>
          <TableCell align="left" className="rowcellcolor rowTableCell myTableRow">
            {row.name_initials ? row.name_initials : 'NA'}
          </TableCell>
          {/* <TableCell align="left" className="rowcellcolor rowTableCell myTableRow">
            {row.provider_name ? row.provider_name : 'NA'}
          </TableCell> */}
          {/* <TableCell align="right" className="rowcellcolor rowTableCell myTableRow">
            {row.charged_amount ? (typeof row.charged_amount === 'string' && row.charged_amount.startsWith('$') ? row.charged_amount : `$${row.charged_amount}`) : 'NA'}
          </TableCell>
          <TableCell align="right" className="rowcellcolor rowTableCell myTableRow">
            {row.paid_amount ? (typeof row.paid_amount === 'string' && row.paid_amount.startsWith('$') ? row.paid_amount : `$${row.paid_amount}`) : 'NA'}
          </TableCell> */}
          <TableCell align="left" className="rowcellcolor rowTableCell myTableRow">
            {row.submitted_date ? getDate(row.submitted_date) : 'NA'}
          </TableCell>
          <TableCell align="left" className="rowcellcolor rowTableCell myTableRow">
            {getStatusBadge(row.status)}
          </TableCell>
          <TableCell align="right" className="rowcellcolor rowTableCell myTableRow" style={{ cursor: 'pointer' }}>
            <IconButton size="small" style={{ padding: '4px' }} onClick={handleMenuOpen}>
              <span style={{ fontSize: '18px', color: '#666' }}>⋯</span>
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <MenuItem onClick={handleUpdate}>Update</MenuItem>
            </Menu>
          </TableCell>
        </TableRow>
      </ThemeProvider>
    </React.Fragment>
  )
}

const useRowStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      borderBottom: 'unset'
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    }
  },
  mobileActionCell: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '45px',
      padding: '4px !important'
    }
  }
}))
